const setIdToQuotes = (quotes, ticketID) => {
  return quotes.map(quote => {
    quote.id = ticketID + quote.objectId
    return quote
  })
}

export default setIdToQuotes